exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".news-view {\n  padding-left: 5px;\n  padding-right: 15px;\n}\n.news-view.loading:before {\n  content: \"Loading...\";\n  position: absolute;\n  top: 16px;\n  left: 20px;\n}\n.news-view .nav {\n  padding: 10px 10px 10px 40px;\n  margin-top: 10px;\n  border-top: 2px solid #f60;\n}\n.news-view .nav a {\n  margin-right: 10px;\n}\n.news-view .nav a:hover {\n  text-decoration: underline;\n}\n", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!../vue-loader/lib/selector.js?style/stylus!./src/views/news-view.vue
 ** module id = 81
 ** module chunks = 0
 **/